// extracted by mini-css-extract-plugin
export default {"label":"SuperCheckbox_label__KvQgi","checkbox":"SuperCheckbox_checkbox__+HmRF","spanClassName":"SuperCheckbox_spanClassName__x1gWB"};